import { MultipleOriginsTransportation } from 'models/MultipleOriginsTransportation/multipleOriginsTransportation.model';
import { serializable, alias, object, list, primitive } from 'serializr';

export class MultipleOriginsProductRawMaterialTransportations {
    @serializable
    id?: number;
  
    @serializable(alias('activity_label', primitive()))
    activityLabel?: string;
  
    @serializable(alias('origin_share', primitive()))
    originShare?: boolean;
  
    @serializable
    type?: string;
  
    @serializable(alias('multiple_origin',list(object(MultipleOriginsTransportation))))
    multipleOrigin?:MultipleOriginsTransportation[]
  
  }